import Loader from './Loader';
export { default as PublishLoader } from './PublishLoader';

export default Loader;
